import request from '@/utils/request'
import { detectiveUrl } from '@/env'

export function info() {
    return request({
        url: `${detectiveUrl()}/api/admin/info`,
        method: 'get'
    })
}

export function adminSignin(state) {
    return request({
        url: `${detectiveUrl()}/api/admin/signin`,
        method: 'post',
        data: state
    })
}
